import { kohSamuiGetYourGuideAttractions } from '../../../config/affiliates/attractions/get-your-guide/koh-samui';
import { Content } from '../../types';

export const kohSamuiContent: Content = {
  title: 'קו סאמוי - פנינת מפרץ תאילנד',
  imageUrl: '/images/thailand/koh-samui/koh-samui-wide.jpeg',
  introduction:
    'בין מי טורקיז נוצצים, חופים לבנים מרהיבים ויערות ירוקים עבותים, שוכן לו האי סאמוי - אחד היעדים הפופולריים והמפתים ביותר בתאילנד. כאן תמצאו חופים מרהיבים, אטרקציות בלתי נשכחות, שווקים צבעוניים, מסעדות מעולות, מגוון אפשרויות לינה וכל מה שצריך בעבור חופשה חלומית באווירה טרופית קסומה.',
  sections: [
    {
      title: 'היכרות עם קו סאמוי - פנינת המפרץ',
      type: 'sub-headers',
      content: [
        {
          subtitle: '',
          text: 'קו סאמוי (Koh Samui) הינו האי השלישי בגודלו בתאילנד וממוקם במפרץ תאילנד. האי משתייך למחוז סוראט תאני ונחשב לאחד מיעדי החופשה הפופולריים ביותר במדינה, בכך שמציע שילוב מושלם של חופים טרופיים, חוויות טבע ייחודיות, חיי לילה תוססים, פעילויות ספורט ימי, ואתרי נופש יוקרתיים.',
        },
        {
          subtitle: '',
          text: 'קו סאמוי - או כפי שהוא מכונה כאן בתאילנד, "פנינת המפרץ" - הינו אחד המקומות הכי קסומים שתפגשו בתאילנד. לא משנה אם הינכם מחפשים חופי זהב בתולי, מסעדות שף משובחות, או חוויות אדרנלין בסגנון האי - פה תמצאו את מבוקשכם ואף מעבר לכך.',
        },
      ],
    },
    {
      title: 'מזג אוויר בקו סאמוי - מתי כדאי לבקר?',
      type: 'sub-headers',
      description:
        'קו סאמוי נהנה ממזג אוויר טרופי ונעים במהלך רוב השנה, מה שהופך אותו ליעד אידיאלי כמעט בכל תקופה. אם הינכם מחפשים חופשה חמה עם הרבה שמש, סאמוי הינו המקום המושלם - אך כדאי לדעת מתי לבקר, כדי להימנע מהמזג האוויר הגשום.',
      content: [
        {
          subtitle: 'עונת השיא (מרץ - ספטמבר)',
          text: 'זוהי התקופה הפופולרית ביותר לביקור בקו סאמוי - מזג האוויר יבש ונעים, עם טמפרטורות בסביבות ה-30 מעלות צלזיוס במהלך היום וערבים קרירים ונעימים. תיירים מכל העולם מגיעים לאי בחודשים האלה, כך שמומלץ להזמין מקומות מראש.',
        },
        {
          subtitle: 'עונת הגשמים (נובמבר - ינואר)',
          text: 'הסופות האקזוטיות מגיעות - לעיתים גשמים טרופיים קצרים ולעיתים ימים סוערים. אם הינכם מבקשים להימנע מתקופות העומס ולהנות מהאי במחירים זולים יותר, זהו הזמן עבורכם, אך קחו בחשבון כי המזג האוויר עשוי להשתנות במהירות.',
        },
        {
          subtitle: 'עונת מעבר (פברואר, ספטמבר - אוקטובר)',
          text: 'עונה זו הינה חמה במיוחד, אך מביאה עימה גם גשמים מעת לעת ופחות תיירים. אם הינכם אוהבים חום אוסטרלי, זו העונה עבורכם.',
        },
        {
          subtitle: 'אז מה כדאי לדעת?',
          text: 'קו סאמוי הינו יעד שמומלץ לבקר בו בעיקר בעונת החורף היבשה, כשיש פחות גשמים ויותר שמש - מה שמאפשר לכם להנות מכל מה שהאי מציע - חופים, חוויות בטבע ואטרקציות ימיות. ואם תבחרו לבקר בעונת הגשמים, אל דאגה - האי עדיין קסום ויש הרבה מה לעשות גם כשיש כמה ימים גשומים (אפשר גם לפנק את עצמכם בספא רומנטי, חוויית אוכל נהדרת או שופינג במרכזי קניות).',
        },
      ],
      sectionLink: {
        url: '/international/thailand/article/thailand-weather',
        text: 'למדריך המלא אודות מזג האוויר בתאילנד',
      },
    },
    {
      title: 'אזורי לינה מומלצים בקו סאמוי',
      type: 'sub-headers',
      sectionLink: {
        url: '/international/thailand/article/koh-samui-family-hotels',
        text: 'הנה הרשימה המומלצת שלנו למלונות למשפחות בקוסמוי',
      },
      description:
        'בקו סאמוי תמצאו שפע של אזורי לינה - מחופים שקטים המתאימים למשפחות ועד מרכזי בילוי תוססים לאוהבי חיי הלילה. כאן תקבלו את האזורים המומלצים והמתאימים לסגנון החופשה שלכם.',
      content: [
        {
          subtitle: "צ'אוונג (Chaweng) - חיי לילה תוססים ואקשן בלתי פוסק",
          text: "אם אתם מחפשים מקום עם הרבה אקשן, חופים תוססים וחיי לילה בלתי נגמרים, צ'אוונג הינו המקום עבורכם. האזור המפורסם ביותר באי מציע שפע של מסעדות, ברים, דוכנים וחנויות. זהו המקום המושך אליו את רוב התיירים, כך שאם אתם אוהבים להיות במרכז העניינים, זה האזור האידיאלי עבורכם. <br />לינה? יש כאן הכל - החל ממלונות 5 כוכבים יוקרתיים ועד דירות זולות ומסבירות פנים.",
        },
        {
          subtitle: 'לאמאי (Lamai) - שילוב בין שקט לאקשן',
          text: "אם אתם מחפשים מקום קצת שקט יותר, אך עדיין מעוניינים בגישה נוחה לחיי לילה ולפעילויות, לאמאי הינו האזור עבורכם. הוא לא רועש כמו הצ'אוונג, אך עדיין יש בו מספיק מסעדות, ברים, חנויות ופעילויות. החוף המהמם של לאמאי מושך אליו זוגות ומשפחות, כך שתמצאו כאן שילוב טוב של רוגע ופעילות.",
        },
        {
          subtitle: 'בופוט (Bophut) - חוויית כפר הדייגים הרומנטית',
          text: 'בופוט הינו המקום הרומנטי ביותר בקו סאמוי, עם "כפר הדייגים" הקסום שנשאר נאמן לאופי התאילנדי האותנטי. כאן תוכלו לטייל בסמטאות הציוריות, לבקר בשוק הלילה הססגוני וליהנות ממסעדות גורמה הממוקמות על החוף. האזור מושלם לזוגות המחפשים חופשה אינטימית ורומנטית.',
        },
        {
          subtitle: 'מאה נאם (Mae nam) - חוף של שלווה והרמוניה',
          text: "אם אתם מחפשים שקט ושלווה, מאה נאם הוא המקום בשבילכם. החוף כאן רחוק מההמולה של צ'אוונג ולאמאי, עם מים רדודים המתאימים למשפחות וילדים. זוהי בחירה מצויינת למבקשים להנות מהחוף בלי המולה ולחוות את קו סאמוי בקצב רגוע יותר.",
        },
        {
          subtitle: "סילבר ביץ' (Silver Beach) - החוף המהודר והקוסם",
          text: "אם אתם מחפשים משהו ייחודי ביותר, החוף הקטן והקסום הזה, הנמצא בין צ'אוונג ללאמאי, הוא בדיוק מה שאתם צריכים. כאן תמצאו לינה מפנקת ואינטימית, עם גישה לחוף פרטי ושקט. המים הצלולים והחוף הלבן יגרמו לכם להרגיש שאתם בגן עדן.",
        },
        {
          subtitle: '',
          text: 'לסיכום, כל אזור בקו סאמוי מציע משהו שונה, תלוי מה הינכם מחפשים בחופשה. בין אם אתם אוהבים אקשן, חופי שלווה או חוויות רומנטיות - אי זה יספק עבורכם את כל מה שצריך כדי לחוות חופשה מושלמת.',
        },
      ],
    },
    {
      title: 'תחבורה ציבורית והתניידות בקו סאמוי',
      type: 'sub-headers',
      description:
        'קל ופשוט להתנייד בקו סאמוי - מגוון אפשרויות תחבורה זמינות עבורכם בכדי לגלות את האי: החל משכירת רכב/ קטנוע, דרך מוניות ועד שירותי הסונגתאו המקומיים. כל מה שצריך לדעת על התניידות נוחה וחסכונית.',
      content: [
        {
          subtitle: 'שירותי מוניות',
          text: 'זמינים אך יקרים יחסית, מומלץ להתמקח מראש על המחיר.',
        },
        {
          subtitle: 'השכרת קטנועים',
          text: 'דרך פופולרית וזולה להתנייד, חשוב להצטייד ברישיון בינלאומי ולחבוש קסדה.',
        },
        {
          subtitle: 'שאטלים ואוטובוסים מקומיים (Songthaew)',
          text: 'דרך חווייתית וחסכונית לנוע בין האזורים המרכזיים באי.',
        },
        {
          subtitle: 'השכרת רכב',
          text: 'נוחה, זולה יחסית ומומלצת מאוד עבור משפחות או קבוצות.',
        },
      ],
    },
    {
      title: 'דרכי הגעה לקו סאמוי ונמלי תעופה',
      type: 'sub-headers',
      description:
        'הגעה לקו סאמוי יכולה להיות חוויה בפני עצמה - בין אם תבחרו בטיסה מהירה או במסע משולב של אוטובוס ומעבורת. כאן תמצאו את כל הדרכים להגיע אל האי הקסום:',
      content: [
        {
          subtitle: 'טיסה ישירה',
          text: "שדה התעופה הבינלאומי של קו סאמוי (Samui Airport) מציע טיסות מבנגקוק, פוקט, צ'אנג מאי ועוד, באמצעות חברת בנגקוק איירווייז, לה שייך השדה.",
        },
        {
          subtitle: 'הגעה משולבת',
          text: 'טיסה לסוראט תאני, העברה למזח דון סאק והפלגה במעבורת לקו סאמוי.',
        },
        {
          subtitle: 'מעבורות/ספיד בואט',
          text: 'מקשרות את קו סאמוי עם קופנגן, קו טאו והיבשת.',
        },
      ],
      is12GoBanner: true,
    },
    {
      title: 'אטרקציות מרכזיות בקו סאמוי',
      type: 'sub-headers',
      description:
        "אוהבים טבע, תרבות, הרפתקאות? בקו סאמוי תמצאו שלל אטרקציות מרתקות לכל גיל ולכל סגנון. מטיולי ג'יפים ונפלאות הטבע ועד חוות פילים ושמורות מרהיבות.<br />קו סאמוי מציע שפע של אטרקציות טבעיות ותרבותיות לכל סוגי המטיילים. כאן תוכלו לתפוס את השמש על החופים, לצאת להרפתקאות אקסטרים בג'ונגל, לגלות מקדשים עתיקים, או פשוט לנוח בספא מפנק. הנה כמה מהאטרקציות שלא כדאי להחמיץ:",
      content: [
        {
          subtitle: 'טיול סובב אי',
          text: "אם אתם מעוניינים לראות את האי בזווית אחרת, תוכלו לעשות זאת באמצעות טיול ג'יפים או טיול עצמאי באמצעות רכב שכור. במהלך הטיול תבקרו במגוון אתרים מרהיבים ואף תיהנו מתצפיות מרהיבות על האי והסביבה. טיול כזה יאפשר לכם הצצה לאתרים הממוקמים במקומות יותר נסתרים ומחוץ לדרכים המרכזיות. בין היתר, מומלץ כי תבקרו במקומות הבאים:<br>✓ <strong>ביג בודהה (Big Buddha Temple)</strong> - פסל מרשים בגובה 12 מטר<br>✓ <strong>מפלי נא מואנג (Na Muang Waterfalls)</strong> - שני מפלים יפיפיים בלב הג'ונגל<br>✓ <strong>סלעי סבא וסבתא (Hin Ta & Hin Yai)</strong> - תצורות סלע ייחודיות ומפורסמות<br>✓ <strong>תצפית לאד קו (Lad Koh Viewpoint)</strong> - נקודת תצפית עוצרת נשימה על קו החוף<br>✓ <strong>הנזיר החנוט (Wat Khunaram)</strong> - מקדש בו נמצאת גופו של נזיר חנוט",
          link: {
            url: kohSamuiGetYourGuideAttractions['full-day-safari-tour'],
            text: "לחצו כאן ובדקו את טיול סובב האי בג'יפ בעצמכם",
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: '',
          text: '',
          link: {
            url: kohSamuiGetYourGuideAttractions[
              'half-day-around-island-tour-with-transfers'
            ],
            text: 'לחצו כאן ובדקו את טיול סובב האי בוואן בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'שמורת הטבע אנג טונג',
          text: 'אם אתם אוהבים טבע פראי ואיים ציוריים, שמורת הטבע אנג טונג הינה חובה. מדובר בארכיפלג ובו 42 איים עם חופים לבנים, לגונות נסתרות ופסגות סלע גיר מרהיבות. תוכלו לשכור קיאקים ולשוט בין האיים, לעשות שנורקלינג במים צלולים ולהתפנק בחוף היפה ביותר באי.',
          link: {
            url: kohSamuiGetYourGuideAttractions['day-tour-to-ang-thong'],
            text: 'לחצו כאן ובדקו את טיול לשמורת הטבע אנג טונג בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'אי החזירים',
          text: 'רוצים חוויות מקוריות? על אי החזירים תמצאו את החוויה האקזוטית של חזירים המסתובבים חופשי על החוף. מעבר לפנינה החמודה הזו, תוכלו גם להנות משנורקלינג במים הצלולים סביב האי ולחוות חיבור לטבע באופן שונה לגמרי.',
          link: {
            url: kohSamuiGetYourGuideAttractions['pig-island'],
            text: 'לחצו כאן ובדקו את טיול לאי החזירים בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'שמורת נאנג יואן וקו טאו',
          text: 'חובבי הצלילה ושוניות האלמוגים, ימצאו את עצמם בגן עדן בשמורת נאנג יואן וקו טאו. המים הצלולים ושוניות האלמוגים המרהיבות הפכו את האיים הללו למוקד עולמי לצוללים. ניתן אף לשכור ציוד שנורקלינג ולהתוודע על עושר החיים התת-ימי במקום.',
          link: {
            url: kohSamuiGetYourGuideAttractions['tour-to-koh-tao-nangyuan'],
            text: 'לחצו כאן ובדקו את טיול לשמורת נאנג יואן וקו טאו בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'חוות פילים שיקומית',
          text: 'אין צורך להרחיק ע"מ לחוות אינטראקציה עם פילים בסביבה טבעית. בקו סאמוי תוכלו לבקר בחוות פילים שיקומית, המספקת טיפול ויחס חמים לפילים. במקום תוכל ללמוד על בעלי החיים המדהימים הללו, להאכיל אותם ולרחוץ איתם וכל זאת ללא התעללות או רכיבה עליהם.',
          link: {
            url: kohSamuiGetYourGuideAttractions['elephant-kingdom-sanctuary'],
            text: 'לחצו כאן ובדקו את טיול לחוות פילים שיקומית בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'סדנאות בישול תאילנדי',
          text: 'אם הינכם חובבי אוכל, סדנאות בישול תאילנדי הן חוויה שלא כדאי לפספס. במהלכן תוכלו ללמוד הכיצד להכין את המנות הקלאסיות של המטבח התאילנדי - כמו פאד תאי, קארי ירוק, סום טאם ועוד - עם מדריכים מקומיים שיסבירו לכם את סודות האוכל המקומי.',
          link: {
            url: kohSamuiGetYourGuideAttractions['thai-cooking-masterclass'],
            text: 'לחצו כאן ובדקו את סדנאות בישול תאילנדי בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'טיול טרקטורונים',
          text: 'אחת הדרכים המהנות ביותר לחקור את פנים האי הינה באמצעות טיול טרקטורונים. המסלול עובר דרך יערות טרופיים, גבעות נוף ותצפיות מרהיבות על קו החוף. במהלך המסלול, אף תעצרו במפלים ובנקודות תצפית נסתרות - חוויה המשלבת אדרנלין, טבע ונופים מהממים.',
          link: {
            url: kohSamuiGetYourGuideAttractions['koh-samui-quad-bike'],
            text: 'לחצו כאן ובדקו את טיול הטרקטורונים בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'אומגות',
          text: "לחובבי אקשן וטבע, פארקי האומגות של קו סאמוי מציעים חוויה עוצרת נשימה בלב הג'ונגל. תגלשו בין צמרות העצים, תיהנו מנופים ירוקים אינסופיים ותרגישו את הרוח על הפנים. פעילות מושלמת לזוגות, משפחות ו/ או קבוצות המעוניינות בקצת ריגוש במסגרת החופשה.",
          link: {
            url: kohSamuiGetYourGuideAttractions[
              'tree-bridge-zipline-and-cafe'
            ],
            text: 'לחצו כאן ובדקו את האומגות בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'מופעי אגרוף תאילנדי',
          text: "אגרוף תאילנדי (מואי תאי) הינו חלק בלתי נפרד מהתרבות המקומית ובקו סאמוי מתקיימים מידי שבוע מופעים מרשימים באצטדיונים מקומיים בחופים צ'אוונג ולאמאי. זוהי הזדמנות לחוות מקרוב את אחד מענפי הספורט המסורתיים והמרהיבים בתאילנד, באווירה סוחפת ועם הרבה אנרגיה.",
          link: {
            url: kohSamuiGetYourGuideAttractions['boxing-stadium-muay-thai'],
            text: 'לחצו כאן ובדקו את מופעי אגרוף תאילנדי בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'מסיבת הפולמון בקו פנגן (עם הפלגות מסאמוי)',
          text: 'אחת החוויות האייקוניות של תאילנד! מסיבת הפולמון המפורסמת מתקיימת מדי חודש בחוף הדרין שבקו פנגן, אך רבים רוצים להגיע אליה מהאי השכן קו סאמוי. הפלגות מיוחדות יוצאות מסאמוי קודם לתחילת המסיבה ומחזירות את המבקרים לאחריה – כך מתאפשר להנות מהמסיבה הססגונית בלי לוותר על הלינה השקטה בסאמוי. לילה אחד של מוזיקה, ריקודים וצבעים זוהרים על החוף.',
          link: {
            url: kohSamuiGetYourGuideAttractions[
              'full-moon-party-tickets-with-round-trip-transfer'
            ],
            text: 'לחצו כאן ובדקו את מסיבות הפולמון בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },

        {
          subtitle: 'קניון סנטרל סאמוי',
          text: 'אוהבים קניות? קניון סנטרל סאמוי הינו מקום מצוין לקניית מותגים, לבקר בחנויות יוקרה וליהנות מאזורי בילוי ומסעדות טובות. המקום גם מציע קומה שלמה של מתחם אוכל המוקדש למטבחים שונים מרחבי העולם.',
        },
        {
          subtitle: '',
          text: 'בשורה התחתונה, בין אם הינכם חובבי טבע, חוויות אקסטרים, או פשוט רוצים להירגע - קו סאמוי מציע מגוון רחב של פעילויות שיתאימו לכלל סוגי המטיילים. האי הזה לא משאיר מקום לשעמום.',
        },
      ],
      tourIds: '659094,539381,245437',
    },
    {
      title: 'ספא ומרכזי בריאות בקו סאמוי',
      type: 'sub-headers',
      description:
        'ספא מפנק מול הים, עיסוי תאילנדי אמיתי, מרכזי יוגה ומדיטציה - קו סאמוי הוא המקום המושלם לתת לגוף ולנפש לנוח ולהתחדש.',
      content: [
        {
          subtitle: 'Tamarind Springs',
          text: 'ספא מיוחד בלב יער גשם, עם סאונות טבעיות שנחצבו באבן ועיסויים מסורתיים באווירה פסטורלית אמיתית.',
        },
        {
          subtitle: 'Eranda Herbal Spa',
          text: "ספא באווירה טרופית, משקיף על חוף צ'אוונג ומתמחה בטיפולים צמחיים עתיקים ועיסויים תאילנדיים מפנקים.",
        },
        {
          subtitle: 'Anantara Spa',
          text: 'חוויית ספא יוקרתית הכוללת סוויטות פרטיות, עיסויי שמנים וטיפולים המשלבים אלמנטים מתרבויות המזרח הרחוק.',
        },
      ],
    },
    {
      title: 'חוויות למשפחות עם ילדים בקו סאמוי',
      type: 'sub-headers',
      description:
        'חוות חיות, פארקי מים, חופים עם מים רדודים והרבה פעילויות לכל המשפחה - גם הילדים ימצאו פה את גן העדן שלהם.',
      content: [
        {
          subtitle: 'Samui Elephant Sanctuary',
          text: 'חוות פילים טיפולית בה הילדים יוכלו להאכיל פילים, ללמוד על ההיסטוריה שלהם ולהתנסות ברחצה יחד עם החיות.',
        },
        {
          subtitle: 'Pink Elephant Water Park',
          text: 'פארק מים מודרני עם מגלשות גדולות, אזור מיוחדטנטנים ובריכת גלים שתשמח את כל המשפחה.',
        },
        {
          subtitle: 'Paradise Park Farm',
          text: 'גן חיות קטן הממוקם בפסגת הר, עם מגוון בעלי חיים ונוף מרהיב לכל האי.',
        },
        {
          subtitle: 'קורסי בישול משפחתיים',
          text: 'חוויה כיפית ילמדו את הילדים ואתכם לבשל מנות תאילנדיות כמו פאד תאי וקארי ירוק, בקלות ובהנאה.',
        },
      ],
    },
    {
      title: 'חוויות רומנטיות וזוגיות בקו סאמוי',
      type: 'sub-headers',
      description:
        'מחפשים להצית את הרומנטיקה? ספא זוגי, הפלגת שקיעה פרטית, מסעדה על חוף מבודד - קו סאמוי הינו מקום מושלם עבור ירח דבש או חופשה זוגית.',
      content: [
        {
          subtitle: 'שייט שקיעה פרטי',
          text: 'הפלגה מפנקת בשעות הזהב על יאכטה פרטית, כולל יין, פירות טרופיים ומוזיקה רגועה.',
        },
        {
          subtitle: 'ארוחת ערב על החוף',
          text: 'דמיינו שולחן מואר בנרות על החול הרך, עם תפריט שף איכותי וגלים הנשברים ברקע.',
        },
        {
          subtitle: 'טקס חידוש נדרים בוילות Anantara Rasananda',
          text: 'טקס אינטימי ומרגש המתקיים על חוף בתולי, בליווי פרחים מקומיים ונופי ים עוצרי נשימה.',
        },
        {
          subtitle: 'Silver Beach',
          text: 'מפרץ חבוי עם מים צלולים וצוקים דרמטיים, מקום מושלם לבריחה שקטה מההמולה.',
        },
      ],
    },
    {
      title: 'צלילות ושנורקלינג - אתרים מומלצים',
      type: 'sub-headers',
      description:
        'קופנגן, קו טאו ושמורת אנג טונג - אזורי הצלילה והשנורקלינג מסביב לקו סאמוי הינם מהטובים שבתאילנד.',
      content: [
        {
          subtitle: 'קו טאו (Koh Tao)',
          text: '"אי הצלילות" של תאילנד, גן עדן למתחילים ולמנוסים כאחד, עם עשרות אתרי צלילה מסודרים.',
        },
        {
          subtitle: 'קו נאנג יואן (Koh Nang Yuan)',
          text: 'אי ייחודי המחובר ברצועת חול לבנה, עם חופים מושלמים לצלילות שטח ושנורקלינג עוצר נשימה.',
        },
        {
          subtitle: 'Shark Bay',
          text: 'חוף קטן ומוגן בצידו הדרומי של קו טאו, בו תוכלו לשחות לצד כרישי שונית ידידותיים וליהנות משוניות אלמוגים יפהפיות.',
        },
        {
          subtitle: 'Hin Wong Bay',
          text: 'מפרץ מבודד בצידו המזרחי של קו טאו, עם מים רגועים ואוצרות תת ימיים צבעוניים.',
        },
      ],
    },
    {
      title: 'מוזיאונים ואתרי תרבות בקו סאמוי',
      type: 'sub-headers',
      description:
        'קו סאמוי, על אף היותו יעד טבעי וחופי, מציע גם חוויות תרבותיות ואומנותיות מעניינות. הנה כמה מהמוזיאונים שעליהם כדאי לדעת:',
      content: [
        {
          subtitle: 'מוזיאון ההיסטוריה של קו סאמוי',
          text: 'אם ברצונכם להבין יותר על ההיסטוריה והתרבות של האי, מוזיאון זה מציע מבט מעמיק על חיי המקומיים, המסורת והתרבות של קו סאמוי. תוכלו לראות תצוגות של עבודות יד מקומיות, כלים חקלאיים ופריטים היסטוריים נוספים המספרים את סיפורו של האי.',
        },
        {
          subtitle: 'מוזיאון האומנות "Art Samui"',
          text: 'למחפשים אומנות מודרנית, מוזיאון Art Samui מציע מבחר מרהיב של יצירות אומנות עכשוויות. המקום מציג עבודות של אמנים תאילנדיים ומקומיים, עם תערוכות מתחלפות המציגות את הגיוון והיצירתיות של האומנים המקומיים.',
        },
        {
          subtitle: 'אתרי תרבות נוספים באי',
          text: '✓ <strong>Wat Plai Laem</strong> - מקדש צבעוני ומרשים ובו פסלים ענקיים של אלים בודהיסטיים.<br>✓ <strong>Secret Buddha Garden</strong> - גן פסלים קסום בלב הרי האי.',
        },
        {
          subtitle: '',
          text: 'בשורה התחתונה, מוזיאונים בקו סאמוי מציעים איזון מושלם בין חוויות חוף וטיולים בטבע ומספקים טעימה של התרבות וההיסטוריה של האי. אם הינכם אוהבים להעמיק ולהתבונן בצדדים תרבותיים של כל יעד, המוזיאונים בקו סאמוי בהחלט לא יאכזבו אתכם.',
        },
      ],
    },
    /////
    {
      title: 'שווקים וקניונים בקו סאמוי',
      type: 'sub-headers',
      description:
        'אם אתם מחפשים חוויית קניות, דוכנים צבעוניים ומזכרות מיוחדות - בקו סאמוי תמצאו משווקים ססגוניים ועד קניון מודרני - יש כאן הכל.',
      content: [
        {
          subtitle: 'שוק הדייגים (Fisherman’s Village)',
          text: 'אחד השווקים המפורסמים ביותר בקו סאמוי אם לא המפורסם שבהם. שוק הדייגים שבחוף בופוט מציע חוויה אותנטית במרכז כפר הדייגים הציורי. כאן תוכלו למצוא שפע של דוכנים המציעים תוצרת מקומית, בגדים, תכשיטים, מזכרות ואומנות מקומית. השוק פעיל במיוחד בימים שני, רביעי ושישי, ויש בו גם מסעדות ובתי קפה עם נוף מרהיב לים.',
        },
        {
          subtitle: 'שוק הלילה בחוף לאמאי (Lamai Night Market)',
          text: 'אם אתם מחפשים חוויית קניות בשעות הערב, השוק הלילי בחוף למאי הינו המקום עבורכם. הוא מציע מבחר רחב של דוכנים המוכרים אוכל רחוב, בגדים, תכשיטים ואומנות. אם אתם אוהבים אווירה חיה ומזמינה, זהו המקום לבילוי ערב קליל.',
        },
        {
          subtitle: 'קניון סנטרל סאמוי (Central Festival Samui)',
          text: 'למחפשים חוויית קניות מודרנית עם מותגים עולמיים, קניון סנטרל סאמוי הוא המקום. כאן תמצאו חנויות יוקרה, מותגי אופנה בינלאומיים, מסעדות מגוונות ואף אזור בילוי עם בית קולנוע, מתחם אוכל ואטרקציות נוספות.',
        },
      ],
    },
    {
      title: 'חיי לילה בקו סאמוי',
      type: 'sub-headers',
      description:
        'כאשר שוקעת השמש, קו סאמוי מתעורר לחיים עם ברים תוססים, מסיבות חוף ושפע של בילויים עד אור הבוקר. כאן תמצאו המלצות לחוויית לילה בלתי נשכחת:',
      content: [
        {
          subtitle: 'ARK Bar',
          text: "אם אתם מחפשים מקום עם אווירה תוססת וצעירה, ה - ARK Bar הוא המקום עבורכם. הוא ממוקם על חוף צ'אוונג ומציע מוזיקה חיה, די ג'ייז מקומיים ואווירה מסיבתית המושכת תיירים ומקומיים כאחד ואל תשכחו להצטלם ליד הבריכות הכחולות שמול הים.",
        },
        {
          subtitle: 'Green Mango Club',
          text: "המועדון האגדי והאייקוני בחוף צ'אוונג. זהו מועדון גדול, צבעוני מאוד ותוסס הממוקם בקצה סוי מנגו (המועדון נתן לרחוב את שמו) ומומלץ מאוד לבקר בו. המסיבות מתחילות בשעות המאוחרות של הלילה ונמשכות עד השעות הקטנות של הלילה - אטרקציה מובילה בחיי הלילה של חוף צ'אוונג.",
        },
        {
          subtitle: 'Koh Samui Pub Crawl',
          text: 'אם אתם מעוניים לחוות את חיי הלילה של האי בסטייל, ה -Pub Crawl  של קו סאמוי הינו הדרך המושלמת. מדובר בסיור מודרך, במסגרתו מבקרים בכמה מהברים המובילים באי והכולל שתייה חופשית, מוזיקה חיה ויכולת להכיר את האי בצורה קלילה ומהנה.',
        },
        {
          subtitle: "Coco Tam's",
          text: "אם אתם מעדיפים מקום עם אווירה פחות מסיבתית אך יותר רגועה, ה-Coco Tam's הינו בר הממוקם בחוף בופוט ומציע חוויית בילוי מפנקת על חוף הים. תוכלו ליהנות מברים באווירה טרופית, מוזיקה חיה וקוקטיילים מעולים. המקום נהדר גם לצפייה בשקיעות מדהימות.",
        },
        {
          subtitle: '',
          text: 'קו סאמוי מציע שלל אפשרויות לחיי לילה - בין אם אתם מחפשים מסיבה תוססת, או אווירה יותר רגועה ומפנקת. כך או כך, לאי חוויות שלא תשכחו!',
        },
      ],
    },
    {
      title: 'טיפים חשובים למטיילים בקו סאמוי',
      type: 'sub-headers',
      description:
        'טרם אריזת המזוודות - ריכזנו עבורכם טיפים חשובים שיעזרו לכם ליהנות מכל רגע בקו סאמוי: מה להביא, למה לשים לב, ואיך להפיק את המקסימום מהחופשה.',
      content: [
        {
          subtitle: 'הימנעו מהחום במרכז היום',
          text: 'מזג האוויר באי יכול להיות חם מאוד, במיוחד בין השעות 12:00 ל-15:00. אם אינכם רגילים לחום טרופי, כדאי להימנע מלטייל בשעות אלה ולחפש מקומות ממוזגים או חופים שקטים. השתדלו לצאת לטיולים בשעות הבוקר המוקדמות או אחרי השקיעה, אז הטמפרטורה נוחה יותר.',
        },
        {
          subtitle: 'קחו עימכם כסף מזומן',
          text: 'למרות שמספר גדול של מקומות מקבלים כרטיסי אשראי, עדיין ישנם מקומות בקו סאמוי, במיוחד בכפרים הקטנים או בשווקים, בהם מומלץ לשלם במזומן. כדאי להצטייד בכסף מזומן מראש, במיוחד עבור מקומות מרוחקים או בזמן ביקור בשווקי לילה.',
        },
        {
          subtitle: 'השכרת רכב או קטנוע',
          text: 'הדרך הטובה והמומלצת ביותר להתנייד בקו סאמוי הינה באמצעות השכרת רכב או קטנוע. האי מציע לא מעט כבישים יפים ונעימים, באמצעותם מאפשר לכם לטייל בקלות ולהגיע למקומות נגישים מבלי להסתמך על תחבורה ציבורית יקרה. בעת השכרת קטנוע, חובה רשיון נהיגה בתוקף, אחרת הביטוח אינו תקף!',
        },
        {
          subtitle: 'היזהרו ממעבורות ונסיעות בסירה',
          text: 'המעבורות המקשרות את קו סאמוי עם איים אחרים כמו קופנגן וקו טאו יכולות להיות חלק מהחוויה, אך מומלץ לבדוק את מזג האוויר לפני כל יציאה. בעת סופה או גשמים, המעבורות יכולות להיות פחות יציבות. במקרים כאלו, כדאי להיות גמישים בתכניות ולהמתין עד שהמצב משתפר.',
        },
        {
          subtitle: 'חפשו את המקומות של המקומיים',
          text: 'אם הינכם מעונינים להימנע מהמוני התיירים ולהתנסות במטעמים ומקומות פחות מתויירים, חפשו את המקומות של המקומיים. תוכלו למצוא חופים ריקים, מסעדות טובות יותר ושווקים המלאים בטעמים אותנטיים במחירים נמוכים יותר.',
        },
        {
          subtitle: 'אל תשכחו להגן על עצמכם מהשמש',
          text: 'השמש בקו סאמוי חזקה מאוד ומומלץ להשתמש בקפידה בקרם הגנה על עורכם וללבוש כובעים או כיסויים כדי להימנע מכוויות שמש. אם הינכם מתכננים בילוי ממושך בחוץ, קחו איתכם מים בכמות מספקת ושימו לב על הימנעות מהתייבשות.',
        },
      ],
    },
    {
      title: 'בשורה התחתונה',
      type: 'text',
      content:
        'קו סאמוי הינו אי עוצר נשימה המשלב בין טבע פראי, חופים מרהיבים, אטרקציות מגוונות, חיי לילה סוערים ואפשרויות רוגע ושלווה. האי מתאים לכל סוגי המטיילים - מזוגות בחופשה רומנטית, דרך משפחות עם ילדים ועד לחובבי אקסטרים והרפתקאות. בין אם הינכם מחפשים חופים שקטים, חוויות קולינריות אותנטיות או טיולים מרגשים בטבע - קו סאמוי יעניק לכם חופשה חלומית שלא תשכחו.',
    },
  ],
};
